import styled from 'styled-components'

import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { breakpoints } from '@/config/layout'

export const StButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-shadow: 0px -1px 20px rgba(4, 24, 49, 0.07);
  background-color: ${({ theme }) => theme.Colors.Background.White};
  box-shadow:
    0px 0px 1px rgba(5, 34, 69, 0.1),
    0px -2px 16px rgba(4, 24, 49, 0.08);
  ${({ theme }) => `
    padding: ${theme.UI.SpacingPx.Space6} ${theme.UI.SpacingPx.Space6};
  `}
`

export const StContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`

export const StButton = styled(Button)`
  @media ${breakpoints.fromS} {
    max-width: 500px;
  }
`

export const StScreenView = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  inset: 0;
`
